module.exports = __webpack_public_path__ + "static/aboutPicture-06724c2c45ca54047128805804b0429e.jpg";